<script setup lang="ts">
/**
 * A state in the office status bar („⚡ Worker“, „Gespeichert“): an item with
 * a fill of its own, so it reads as a state rather than as one more value.
 * `brand` is the bar's own quiet step, `success` / `warning` the status fills —
 * each with its intent's `-fg` text.
 */
import '../office-statusbar.css';

const props = withDefaults(
  defineProps<{
    tone?: 'brand' | 'success' | 'warning';
  }>(),
  { tone: 'brand' }
);
</script>

<template>
  <span
    class="nx-office-statusbar__item nx-office-statusbar__badge"
    :class="`nx-office-statusbar__badge--${props.tone}`"
  >
    <slot />
  </span>
</template>
